module.exports = __webpack_public_path__ + "static/media/add.f5915b2d.svg";